import { Component, Input } from '@angular/core';
import { KybStatusDisplay, kybStatusSourceLabel } from '@portal-workspace/grow-shared-library';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';

@Component({
  selector: 'kyb-status-chip',
  templateUrl: './kyb-status-chip.component.html',
  styleUrls: ['./kyb-status-chip.component.scss'],
  standalone: true,
  imports: [MatTooltipModule, NgClass],
})
export class KybStatusChipComponent {
  @Input({ required: true }) status!: KybStatusDisplay;

  get tooltip(): string {
    return kybStatusSourceLabel(this.status.source);
  }

  /** Workflow results use the existing muted chip treatment. */
  colourClass(): string {
    return 'muted';
  }
}
